import BuildingListModelBase from '../_generated/modelBases/building-list-model-base';

export default class BuildingListModel extends BuildingListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
